/**
 * @generated SignedSource<<c72891f76af0c764f36a39297382d142>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type answersStatisticsTable_Fragment$data = {
  readonly Admin: {
    readonly Statistic: {
      readonly AnswersStatistic: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly elementStatistics: ReadonlyArray<{
              readonly answerStatistics: ReadonlyArray<{
                readonly checkedTimes: number;
                readonly index: number;
                readonly isCorrect: boolean;
              }>;
              readonly correctPercentage: number;
              readonly elementId: string;
              readonly question: string;
              readonly totalTries: number;
            }>;
            readonly rootNodeId: string;
            readonly rootNodeTitle: string;
          };
        } | null | undefined> | null | undefined;
      };
    };
  };
  readonly " $fragmentType": "answersStatisticsTable_Fragment";
};
export type answersStatisticsTable_Fragment$key = {
  readonly " $data"?: answersStatisticsTable_Fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"answersStatisticsTable_Fragment">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "Admin",
  "Statistic",
  "AnswersStatistic"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filterByTagIds"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filterByTitle"
    },
    {
      "defaultValue": 1,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "greaterThanDate"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "lessThanDate"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": require('./answersStatisticsTable_Refetch.graphql')
    }
  },
  "name": "answersStatisticsTable_Fragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AdminQueryType",
      "kind": "LinkedField",
      "name": "Admin",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "StatisticAdminSchema",
          "kind": "LinkedField",
          "name": "Statistic",
          "plural": false,
          "selections": [
            {
              "alias": "AnswersStatistic",
              "args": [
                {
                  "kind": "Variable",
                  "name": "filterByTagIds",
                  "variableName": "filterByTagIds"
                },
                {
                  "kind": "Variable",
                  "name": "filterByTitle",
                  "variableName": "filterByTitle"
                },
                {
                  "kind": "Variable",
                  "name": "greaterThanDate",
                  "variableName": "greaterThanDate"
                },
                {
                  "kind": "Variable",
                  "name": "lessThanDate",
                  "variableName": "lessThanDate"
                }
              ],
              "concreteType": "NodeQuestionAndAnswersTriesConnection",
              "kind": "LinkedField",
              "name": "__answersStatisticsTable_AnswersStatistic_connection",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "NodeQuestionAndAnswersTriesEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "NodeQuestionAndAnswersTries",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "rootNodeId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "rootNodeTitle",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ElementStatistics",
                          "kind": "LinkedField",
                          "name": "elementStatistics",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "elementId",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "question",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "totalTries",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "correctPercentage",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "AnswerStatistics",
                              "kind": "LinkedField",
                              "name": "answerStatistics",
                              "plural": true,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "checkedTimes",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "index",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "isCorrect",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "__typename",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "cursor",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PageInfo",
                  "kind": "LinkedField",
                  "name": "pageInfo",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "endCursor",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasNextPage",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "28d580dbca95b87b86f6c73686ea4a55";

export default node;
